import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterRoleSelect({
  disabled = false,
  value = null,
  onChange = () => null,
}) {
  const { t } = useTranslate()

  const filterRoles = useStoreState((state) => state.filter.roles)

  const getFilterRoles = useStoreActions((actions) => actions.filter.getRoles)

  const options = _.map(filterRoles, (filterRole) => {
    return {
      label: filterRole?.name,
      value: filterRole?.id,
    }
  })

  useAsync(async () => {
    getFilterRoles()
  }, [])

  const selectProps = {
    defaultValue: value,
    disabled,
    options,
    placeholder: t('Role'),
    onChange,
  }

  return (
    <Styled className="filter-role-select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
